import type { Location } from '@/common/types/teams.types'

export interface TeamsState {
  locations: Location[]
  isModalOpen: boolean
}

export const initialTeamsState: TeamsState = {
  locations: [],
  isModalOpen: false,
}
